import React from 'react';
import { ChevronRight } from 'lucide-react';
import './StatCard.css';

/**
 * StatCard v2
 * Props: label, value, icon (Lucide component), color (gold|success|danger|info),
 *        onClick (makes card clickable), ctaLabel
 */
const StatCard = ({ label, value, icon: Icon, color = 'gold', onClick, ctaLabel = 'View details' }) => (
  <div
    className={`stat-card stat-card-${color} animate-in ${onClick ? 'clickable' : ''}`}
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
  >
    <div className="stat-icon-wrap">
      {Icon && <Icon size={22} strokeWidth={1.75} />}
    </div>
    <div className="stat-content">
      <div className="stat-value">{value ?? '—'}</div>
      <div className="stat-label">{label}</div>
      {onClick && (
        <div className="stat-cta">
          {ctaLabel} <ChevronRight size={11} />
        </div>
      )}
    </div>
  </div>
);

export default StatCard;
